import React, { useEffect, useState } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import './PropertyPage.css'; // Add CSS file for styling
import PropertyInfo from './PropertyInfo';

const PropertyPage = () => {
  const { customerId, taxid, taxyear } = useParams();
  const { dataClient, dataProperty } = useOutletContext(); // Use object destructuring for context
  
  const [dataTax, setDataTax] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTaxData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_PROXY_URL}/api/taxPropertyDetail/${customerId}/${taxid}/${taxyear}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        setDataTax(result.data?.result || result); // Safely access nested data
      } catch (error) {
        console.error('Error fetching tax data:', error);
        setError(error);
      }
    };

    fetchTaxData();
  }, [customerId, taxid, taxyear]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!dataTax) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container">
      <div className="content">
        {dataProperty ? (
          <PropertyInfo dataProperty={dataProperty} />
        ) : (
          <div>Loading...</div>
        )}
      </div>
      <table className="responsive-table">
        <thead>
          <tr>
            <th>Class</th>
            <th>Description</th>
            <th>District</th>
            <th>Quantity</th>
            <th>Market</th>
            <th>Taxable/$</th>
          </tr>
        </thead>
        <tbody>
          {dataTax.map((item, index) => (
            <tr key={index}>
              <td>{item.classClass}</td>
              <td>{item.description.trim()}</td>
              <td>{item.district.trim()}</td>
              <td>{item.quantity.toFixed(2)}</td>
              <td>{item.marketValue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
              <td>{item.taxable.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PropertyPage;
